/**
 * 单个车辆转移
 */
import React, {useState, forwardRef, useImperativeHandle, useRef, useEffect, useLayoutEffect} from "react";
import {SimpleTreeUpdate,AuthButton,WWTable} from "@/globalComponents";
import {Modal, Input, Button, message, Popconfirm} from "antd";
import "@/assets/styles/modal.scss"
import {WWMethods,WWUtils} from "@/tools";
import BatchCheckModal from "../components/BatchCheckModal";
const TextArea = Input.TextArea;
function BatchTransferVins(props, ref){
    const [orgId,setOrgId] = useState("");
    const [organizationName,setOrganizationName] = useState(localStorage.getItem("organizationName"))
    const [visible,setVisible] = useState(false);
    const [title,setTitle] = useState(Strings.transforcars || "转移车辆信息")
    const [imeiSet,setImeiSet] = useState([])
    const [hasList,setHasList] = useState(false)
    const [deviceData,setDeviceData] = useState([]);
    const batchCheckRef = useRef(null);
    const tree_Ref_bathTransfer = useRef(null);
    const [imeis,setImeis] = useState("")
    //暴露给父组件的方法
    useImperativeHandle(ref, () => ({
        showModal:()=>{
           setVisible(true)
        }
    }));

    useEffect(()=>{

    },[])
    const hideModal = ()=>{
        setVisible(false);
        setImeis("");
        setImeiSet([]);
        setHasList(false);
        setOrgId("");
        setDeviceData([])
    }
    const handleAccountChange = (id,name)=>{
        setOrgId(id);
        setOrganizationName(name)

    }
    const transferVin = ()=>{
        let verification = false;
        let array = [];
        imeiSet.forEach(function (item, index) {
            if (!WWUtils.isNumber(item)) {
                verification = true;
            }
            if(!WWUtils.isNull(item)){
                array.push(item.trim())
            }
        });

        if (array.length > 500) {
            message.warning(Strings.rs10410 || "设备号不能超过500个")
            return
        }
        let params = {
            targetOrgId:orgId,
            carCodes:array
        }
        WWMethods.transferVins(params,(data)=>{
            if(data.code === 0){
                if( data.data){
                    let {successCars,errors} = data.data;
                    if(errors && errors.length){
                        batchCheckRef.current.showModal(errors,successCars)
                    }
                }else{
                    message.success("转移成功")
                    hideModal();
                    props.refresh();
                }
            }
        })
    }
    //更添加的设备新输入内容
    const handleImeiSet = (e)=>{
        let imeiSet = e.target.value.trim().split(/[\n\s+,\s+，]/g);//按空格、换行符、逗号分隔符正则表达式 分割数组
        setImeiSet(imeiSet);
        setImeis(e.target.value);
    }
    const getBatchImei = ()=>{
        let verification = false;
        if (!imeiSet.length) {
            message.warning(Strings.rs10409 || "请输入设备号")
            return;
        }
        let array = [];
        imeiSet.forEach(function (item, index) {
            if (!WWUtils.isNumber(item)) {
                verification = true;
            }
            if(!WWUtils.isNull(item)){
                array.push(item.trim())
            }
        });

        if (array.length > 500) {
            message.warning(Strings.rs10410 || "设备号不能超过500个")
            return
        }
        let params = {
            targetOrgId: orgId,
            carCodes:array
        }
        WWMethods.transferVinCheck(params,(data)=>{
            const {successCars, errors} = data
            if (successCars) {
                setHasList(true);
                let deviceData_temp= JSON.parse(JSON.stringify(deviceData));
                 deviceData_temp = deviceData_temp.concat(successCars);
                let hash = {};
                deviceData_temp = deviceData_temp.reduce(function (item, next) {
                    hash[next.carCode] ? '' : hash[next.carCode] = true && item.push(next);
                    return item
                }, []);
                setDeviceData(deviceData_temp);
                let imeiSet_temp = [];
                deviceData_temp.forEach(function (item) {
                    imeiSet_temp.push(item.carCode);
                });
                setImeiSet(imeiSet_temp)
            }
            if(errors && errors.length) {
                batchCheckRef.current.showModal(errors,successCars)
            }
        })
    }
    const deleteRecord = (index)=> {
        let data = JSON.parse(JSON.stringify(deviceData));
        let imeiSet_temp = JSON.parse(JSON.stringify(imeiSet));
        let imei = data[index].imei;
        data.splice(index, 1);
        imeiSet_temp = imeiSet_temp.filter((item,i)=>item !== imei);
        let imeis = imeiSet_temp.join("\n")
        setDeviceData(data)
        setImeis(imeis)
        setImeiSet(imeiSet_temp)
    }
    const columns = [
        {
            title: Strings.carCode || "机械编号",
            dataIndex: 'carCode',
            width: '25%'
        }, {
            title: Strings.curOrgName  || "当前所属用户",
            dataIndex: 'orgName',
            width: '25%'
        }, {
            title: Strings.opts || "操作",
            dataIndex: '',
            width: '20%',
            render: (text, record, index) =>{
                return <Popconfirm title={Strings.sureDel || "确认删除？"}   onConfirm={() => {deleteRecord(index)}}
                                   okText={Strings.sure || "确定"}
                                   cancelText={Strings.cancel || "取消"}><i className={"icon blue iconfont icon-shanchu"}></i></Popconfirm>
            }
        }];
    return (
        <Modal {...props} ref={ref} transitionName="" maskTransitionName="" visible={visible}
               className={"default_modal"} destroyOnClose={true}
               maskClosable={false} title={title}
               width={654}
               onCancel={() => {
                   hideModal();
               }} footer={null}>

            <div className={"modal_item"}>
                <label className={"font"}>{Strings.transferTo || "转移至"}：</label>
                <div className={`transferVins_tree_wrapper tree_wrapper`}
                     style={{display:"inline-block",position:"relative"}}>
                    <SimpleTreeUpdate ref={tree_Ref_bathTransfer}
                                      selectWidth={240}
                                      margins={"5px auto"}
                                      organizationId={orgId}
                                      showSelect={true}
                                      parentClass={`transferVins_tree_wrapper`}
                                      directShowTree={false}
                                      showRootName={false}
                                      isTallTree={true}
                                      disRootSelected={true}//默认不选中根节点
                                      handleChange={handleAccountChange}
                                      sendAccountId={handleAccountChange}
                    />
                </div>
            </div>
            <div className={"modal_item fs"}>
                <label className={"font"}>{Strings.addmore || "追加车辆："}</label>
                <TextArea className={"bigInputArea"}
                          rows={3}
                          value={imeis}
                          style={{ resize: 'none'}}
                          onChange={handleImeiSet}/>
                <AuthButton type={"primary"} className={"mgl0"} authKey={true} onClick={()=>getBatchImei()}>{Strings.add || "添加"}</AuthButton>
            </div>
            <div className="modal_item">
                <span className="form_span null_span"></span>
                <label className={"font"}>{Strings.batchInput || "输入完整的机械编号，每行输入一个机械编号"}</label>
            </div>
                {!props.hideTable || hasList?<div className="modal_item right">
                    <span className="form_span" style={{width: "auto"}}>{Strings.current || "当前"} {deviceData.length}</span>
                </div>:null}
            {!props.hideTable || hasList ?
                <div className="modal_item wwtable" >
                    <WWTable className={"new_app_table"}  columns={columns} innerHeight={350} height={0}
                             dataSource={deviceData}  pagination={false} hiddenPagination={true}/>
                </div>:null}
            <div className="modal_item modal_btns">
                <AuthButton authKey={true}  onClick={()=>{  hideModal()}}>{Strings.cancel || "取消" }</AuthButton>
                <AuthButton authKey={true} className="mg_left10" type="primary" onClick={()=>{transferVin()}}>{Strings.sure || "确定"}</AuthButton>
            </div>
            <BatchCheckModal handleImeiSet={handleImeiSet} ref={batchCheckRef}/>
        </Modal>
    )
}
export default forwardRef(BatchTransferVins)